import React from 'react';
export function ConversionFunnel() {
  const funnelSteps = [{
    label: 'Link visits',
    count: '1,240',
    width: '100%',
    color: 'bg-[#b8a06a]'
  }, {
    label: 'Photos sent',
    count: '384',
    width: '31%',
    color: 'bg-[#4a8adc]'
  }, {
    label: '3D created',
    count: '247',
    width: '20%',
    color: 'bg-[#9a70dc]'
  }, {
    label: 'Consultation',
    count: '172',
    width: '14%',
    color: 'bg-[#d8902a]'
  }, {
    label: 'Converted',
    count: '98',
    width: '8%',
    color: 'bg-[#4ac88a]'
  }];
  return <div className="bg-[#060c18] border border-[#0e1826] rounded-xl p-6 flex flex-col h-full" data-id="element-1">
      <h2 className="text-lg font-bold text-[#f0ead8] mb-6" data-id="element-2">
        Conversion funnel
      </h2>

      <div className="space-y-4 mb-8" data-id="element-3">
        {funnelSteps.map(step => <div key={step.label} className="flex items-center justify-between text-sm" data-id="element-4">
            <span className="text-[#3a5070] w-28" data-id="element-5">{step.label}</span>
            <div className="flex-1 mx-4 h-1.5 bg-[#0e1826] rounded-full overflow-hidden flex" data-id="element-6">
              <div className={`h-full rounded-full ${step.color}`} style={{
            width: step.width
          }} data-id="element-7" />
            </div>
            <span className="text-[#3a5070] font-medium w-12 text-right" data-id="element-8">
              {step.count}
            </span>
          </div>)}
      </div>

      <div className="h-px bg-[#0e1826] w-full mb-6" data-id="element-9"></div>

      <div className="space-y-4 text-sm" data-id="element-10">
        <div className="flex items-center justify-between" data-id="element-11">
          <span className="text-[#3a5070]" data-id="element-12">GHL pipeline sync</span>
          <div className="flex items-center gap-2" data-id="element-13">
            <span className="text-[#4ac88a] font-medium" data-id="element-14">Live</span>
            <div className="w-2 h-2 rounded-full bg-[#4ac88a]" data-id="element-15"></div>
          </div>
        </div>
        <div className="flex items-center justify-between" data-id="element-16">
          <span className="text-[#3a5070]" data-id="element-17">Avg. 3D view time</span>
          <span className="text-[#f0ead8] font-bold" data-id="element-18">4m 32s</span>
        </div>
        <div className="flex items-center justify-between" data-id="element-19">
          <span className="text-[#3a5070]" data-id="element-20">Patients viewed 3D</span>
          <span className="text-[#f0ead8] font-bold" data-id="element-21">211 / 247</span>
        </div>
      </div>
    </div>;
}